var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#00A0F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8862 12.3475L11.3031 12.3475C10.0312 12.3475 9 13.3788 9 14.6506L9 17.6975C9 18.9688 10.0312 20 11.3031 20L18.2594 20C19.5312 20 20.5625 18.9687 20.5625 17.6975L20.5625 14.6444C20.5625 13.3762 19.5344 12.3475 18.2662 12.3475L17.6769 12.3475",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.605 9.82909C12.4102 10.0248 12.4109 10.3414 12.6066 10.5362C12.8023 10.731 13.1189 10.7303 13.3137 10.5346L14.2812 9.56275L14.2812 15.8772C14.2812 16.1533 14.5051 16.3772 14.7812 16.3772C15.0574 16.3772 15.2812 16.1533 15.2812 15.8772L15.2812 9.5625L16.2494 10.5347C16.4443 10.7303 16.7609 10.731 16.9566 10.5361C17.1522 10.3413 17.1529 10.0247 16.958 9.82903L15.1458 8.00934C15.0546 7.91223 14.925 7.85157 14.7812 7.85157C14.6379 7.85157 14.5086 7.9119 14.4175 8.00855L12.605 9.82909Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.37f5c1d4.svg";
export { ForwardRef as ReactComponent };